var _style, _defs, _mask, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPaymentAmountRegistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 24",
    style: {
      enableBackground: "new 0 0 36 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_3560_28495_00000085217100480088981000000005443488297048694186_);}\r\n\t.st2{fill:#15B79E;}\r\n\t.st3{fill:#F59E0B;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 18,
    height: 14
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    id: "mask0_3560_28495_00000085217100480088981000000005443488297048694186_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12,16.3c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1 c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.3,0.1,0.4C11.7,16.3,11.9,16.3,12,16.3z M12,12.5c0.1,0,0.3,0,0.4-0.1 c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.1,0.2-0.1,0.4 c0,0.1,0,0.3,0.1,0.4C11.7,12.5,11.9,12.5,12,12.5z M12,8.7c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3-0.1-0.4 c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.3,0.1,0.4C11.7,8.6,11.9,8.7,12,8.7z M19.4,19 H4.6c-0.4,0-0.8-0.2-1.1-0.5C3.2,18.2,3,17.8,3,17.4v-2.6c0.6-0.2,1.1-0.6,1.4-1.1C4.8,13.2,5,12.6,5,12s-0.2-1.2-0.6-1.7 C4.1,9.8,3.6,9.4,3,9.2V6.6c0-0.4,0.2-0.8,0.5-1.1C3.8,5.2,4.2,5,4.6,5h14.8c0.4,0,0.8,0.2,1.1,0.5C20.8,5.8,21,6.2,21,6.6v2.6 c0,0.3,0,0.8,0,1.3s0,0.9,0,1.5s0,1,0,1.7c0,0.8,0,0.3,0,1.1v2.6c0,0.4-0.2,0.8-0.5,1.1C20.2,18.8,19.8,19,19.4,19z M19.4,18 c0.2,0,0.3-0.1,0.4-0.2s0.2-0.3,0.2-0.4v-1.9c0-0.9,0-0.4,0-1.4c0-0.7,0-1.3,0-2s0-1,0-2c0-0.5,0-0.5,0-1.4V6.6 c0-0.2-0.1-0.3-0.2-0.4C19.7,6.1,19.6,6,19.4,6H4.6C4.4,6,4.3,6.1,4.2,6.2C4.1,6.3,4,6.4,4,6.6v1.9C4.6,8.9,5.1,9.4,5.5,10 C5.8,10.6,6,11.3,6,12s-0.2,1.4-0.5,2c-0.4,0.6-0.8,1.1-1.5,1.5v1.9c0,0.2,0.1,0.3,0.2,0.4C4.3,17.9,4.4,18,4.6,18H19.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Exclamation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st3",
    d: "M26,15.5c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3s0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.3-0.1 c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.3C25.8,15.5,25.9,15.5,26,15.5z M25.7,12.9h0.8V8.1h-0.8V12.9z  M26,19.2c-1,0-1.9-0.2-2.8-0.6s-1.6-0.9-2.3-1.5c-0.6-0.6-1.2-1.4-1.5-2.3C19,13.9,18.8,13,18.8,12s0.2-1.9,0.6-2.8 s0.9-1.6,1.5-2.3c0.6-0.6,1.4-1.2,2.3-1.5C24.1,5,25,4.8,26,4.8s2,0.2,2.8,0.6c0.9,0.4,1.6,0.9,2.3,1.5c0.6,0.6,1.2,1.4,1.5,2.3 c0.4,0.9,0.6,1.8,0.6,2.8s-0.2,1.9-0.6,2.8c-0.4,0.9-0.9,1.6-1.5,2.3c-0.6,0.6-1.4,1.2-2.3,1.5C28,19,27,19.2,26,19.2z M26,18.4 c1.8,0,3.3-0.6,4.5-1.9c1.2-1.2,1.9-2.7,1.9-4.5c0-1.8-0.6-3.3-1.9-4.5c-1.2-1.2-2.7-1.9-4.5-1.9s-3.3,0.6-4.5,1.9 c-1.2,1.2-1.9,2.7-1.9,4.5c0,1.8,0.6,3.3,1.9,4.5C22.8,17.8,24.3,18.4,26,18.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPaymentAmountRegistryIcon);
export default __webpack_public_path__ + "static/media/empty-payment-amount-registry-icon.92440bb2641c9cf40c29e81e96e6384b.svg";
export { ForwardRef as ReactComponent };